(() => {
  const closeOtherMenus = (active) => {
    document
      .querySelectorAll('.msz-header__mobile[open]')
      .forEach((menu) => {
        if (menu !== active) {
          menu.removeAttribute('open');
        }
      });
  };

  document.addEventListener(
    'toggle',
    (event) => {
      const target = event.target;

      if (
        target.matches &&
        target.matches('.msz-header__mobile') &&
        target.open
      ) {
        closeOtherMenus(target);
      }
    },
    true
  );

  document.addEventListener('click', (event) => {
    document
      .querySelectorAll('.msz-header__mobile[open]')
      .forEach((menu) => {
        if (!menu.contains(event.target)) {
          menu.removeAttribute('open');
        }
      });
  });

  const enhanceHero = (hero) => {
    if (!hero || hero.dataset.mszReady === 'true') {
      return;
    }

    hero.dataset.mszReady = 'true';

    const visual = hero.querySelector('[data-msz-hero-visual]');
    const object = hero.querySelector('[data-msz-hero-object]');

    if (!visual || !object) {
      return;
    }

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    const finePointer = window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    ).matches;

    if (reducedMotion || !finePointer) {
      return;
    }

    let animationFrame = 0;

    visual.addEventListener(
      'pointermove',
      (event) => {
        cancelAnimationFrame(animationFrame);

        animationFrame = requestAnimationFrame(() => {
          const rect = visual.getBoundingClientRect();

          const x =
            ((event.clientX - rect.left) / rect.width - 0.5) * 2;

          const y =
            ((event.clientY - rect.top) / rect.height - 0.5) * 2;

          object.style.transform =
            `rotateX(${(-y * 2).toFixed(2)}deg) ` +
            `rotateY(${(x * 3).toFixed(2)}deg)`;
        });
      },
      { passive: true }
    );

    visual.addEventListener(
      'pointerleave',
      () => {
        cancelAnimationFrame(animationFrame);
        object.style.transform = '';
      },
      { passive: true }
    );
  };

  document
    .querySelectorAll('[data-msz-hero]')
    .forEach(enhanceHero);

  document.addEventListener('shopify:section:load', (event) => {
    enhanceHero(
      event.target.querySelector('[data-msz-hero]')
    );
  });
})();